const EyeClosedIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 14 11" fill="none">
      <path
        d="M6.03327 3.37744L5.73438 1"
        stroke="#BDC2C5"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.18968 3.96497L3.09375 1.8457"
        stroke="#BDC2C5"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5026 5.1922L1 3.37744"
        stroke="#BDC2C5"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.9668 3.37744L8.26569 1"
        stroke="#BDC2C5"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.81055 3.96497L10.9065 1.8457"
        stroke="#BDC2C5"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.498 5.1922L13.0007 3.37744"
        stroke="#BDC2C5"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.0008 8.60042C7.97098 8.60042 8.75746 7.77924 8.75746 6.76627C8.75746 5.7533 7.97098 4.93213 7.0008 4.93213C6.03062 4.93213 5.24414 5.7533 5.24414 6.76627C5.24414 7.77924 6.03062 8.60042 7.0008 8.60042Z"
        stroke="#BDC2C5"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33984 6.76624C1.33984 6.76624 3.09424 3.30127 7.00065 3.30127C10.9071 3.30127 12.6615 6.76624 12.6615 6.76624C12.6615 6.76624 10.9071 10.2307 7.00065 10.2307C3.09424 10.2307 1.33984 6.76624 1.33984 6.76624Z"
        stroke="#BDC2C5"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EyeClosedIcon;
